import styled from 'styled-components';

// INFO: Wrapper used to pass id,role and name to the rio Sidebar
export const DocumentViewerRegion = styled.div`
  height: 100%;
`;
